import React, { useCallback, useState } from 'react';
import InputMask from 'react-input-mask';
import { Button, Input } from 'react-rainbow-components';

import { Message } from '../../components';
import { BOT_NAME } from '../../constants';
import { generateUniqueId } from '../../helpers/utils';
import { createLeader } from '../../services/chatbot';

interface Props {
  onResponded: () => void;
}

const Form: React.FC<Props> = ({ onResponded }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setLoading(true);
    await createLeader(email, name, phone).then(() => onResponded());
    setLoading(false);
  }

  const buttonIsDisabled = useCallback(() => {
    // Validação do Nome
    if (name.length < 3 || name.split(' ').length <= 1) {
      return true;
    }

    // Validação do E-mail
    if (!RegExp(/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/).test(email)) {
      return true;
    }

    // Validação do Celular
    if (!RegExp(/^\([1-9]{2}\) 9[7-9]{1}[\d]{3}-[\d]{4}$/).test(phone)) {
      return true;
    }

    return false;
  }, [email, name, phone]);

  return (
    <form onSubmit={handleSubmit}>
      <p>
        O teste é super rápido. É só seguir o passo a passo,
        registre aqui seu nome, e-mail e número do WhatsApp para receber o resultado no final do teste.
      </p>
      <Input
        label="Nome Completo"
        name="nome"
        onChange={(e) => setName(e.target.value)}
        placeholder="João Batista"
        required
        value={name}
      />
      <Input
        label="E-mail"
        name="email"
        onChange={(e) => setEmail(e.target.value.toLowerCase())}
        placeholder="jb@unilasallelucas.edu.br"
        required
        style={{ padding: '10px 0 10px 0' }}
        type="email"
        value={email}
      />
      <InputMask
        mask="(99) 99999-9999"
        maskChar={null}
        onChange={(e) => setPhone(e.target.value)}
        value={phone}
      >
        {(props) => (
          <Input
            {...props}
            label="WhatsApp"
            name="whatsapp"
            placeholder="(65) 91234-5678"
            required
            type="tel"
          />
        )}
      </InputMask>
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 10 }}>
        <Button
          disabled={buttonIsDisabled() || loading}
          isLoading={loading}
          label="Iniciar Teste"
          type="submit"
          variant="success"
        />
      </div>
    </form>
  );
}

const Leader: React.FC<Props> = ({ onResponded }) => (
  <Message
    date={new Date()}
    id={generateUniqueId()}
    name={BOT_NAME}
    owner="bot"
    text={<Form onResponded={onResponded} />}
  />
);

export default Leader;
